'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg20 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 20, height: 21, viewBox: "0 0 20 21", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.37221 6.15094C0.911555 6.54701 0.859196 7.24152 1.25526 7.70217L8.43897 16.0574C8.44878 16.0688 8.45875 16.0804 8.46884 16.0921C8.61764 16.2654 8.79588 16.473 8.97281 16.6283C9.18505 16.8145 9.53672 17.0552 10.0313 17.0552C10.5259 17.0552 10.8776 16.8145 11.0898 16.6283C11.2667 16.473 11.445 16.2654 11.5938 16.0922C11.6039 16.0804 11.6138 16.0688 11.6237 16.0574L18.7446 7.77534C19.1407 7.31469 19.0883 6.62018 18.6277 6.22411C18.167 5.82804 17.4725 5.88039 17.0765 6.34104L10.0313 14.5349L2.92344 6.26789C2.52738 5.80723 1.83287 5.75487 1.37221 6.15094Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg20;
//# sourceMappingURL=20.js.map
